<script>
  export let error = null;
  export let blur = null;
  export let showActions = true;
  export let fill = false;
</script>

<div class="field-value" class:blur class:error class:fill={!showActions || fill} {...$$props}>
  <slot />
</div>

<style lang="scss" src="./value.scss"></style>
